'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PropertyDropdown = require('./components/PropertyDropdown.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PropertyDropdown).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/property-dropdown/index.js
// module id = 1051
// module chunks = 0